import React from "react";
import { graphql } from "gatsby";
import { motion } from "framer-motion";
import { PrismicRichText } from "@prismicio/react";
import * as styles from "./licensed.module.css";
import { GatsbyImage } from "gatsby-plugin-image";

export const Licensed = ({ slice }) => {
  const { heading, copy, featured_image } = slice?.primary || {};

  return (
    <section
      className={styles.container}
      data-color-scheme="white"
      data-highlight-background="aqua"
      data-highlight-foreground="black"
      data-tilt-scheme="left"
    >
      <motion.div
        className={styles.graphic}
        initial={{ opacity: 0, x: -50 }}
        whileInView={{ opacity: 1, x: 0 }}
        viewport={{ once: true, margin: "-100px" }}
        transition={{ duration: 0.8, ease: [0.25, 0.1, 0.25, 1] }}
      >
        <GatsbyImage
          image={featured_image.gatsbyImageData}
          alt={featured_image.alt || ""}
        />
      </motion.div>
      <motion.div
        className={styles.content}
        initial={{ opacity: 0, x: 50 }}
        whileInView={{ opacity: 1, x: 0 }}
        viewport={{ once: true, margin: "-100px" }}
        transition={{ duration: 0.8, delay: 0.1, ease: [0.25, 0.1, 0.25, 1] }}
      >
        {heading && (
          <PrismicRichText
            field={heading.richText}
            components={{
              heading2: ({ children }) => <h2 className="h1">{children}</h2>,
            }}
          />
        )}
        {copy && <PrismicRichText field={copy.richText} />}
      </motion.div>
    </section>
  );
};

export const query = graphql`
  fragment HomepageDataBodyLicensed on PrismicHomepageDataBodyLicensed {
    primary {
      heading {
        richText
      }
      copy {
        richText
      }
      featured_image {
        gatsbyImageData(placeholder: BLURRED)
        alt
      }
    }
  }
`;
